export const alertsHeadCells = [
  {
    id: 'payDateCurrent',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Дата зачисления',
    style: { maxWidth: '100px' },
  },
  {
    id: 'companyName',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Имя компании',
  },
  {
    id: 'accountId',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Номер аккаунта',
  },
  {
    id: 'typePayCurrent',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Тип платежа',
  },
  {
    id: 'textAlignRight',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Сумма ',
  },
  {
    id: 'comment',
    numeric: false,
    disablePadding: false,
    disableSort: true,
    label: 'Комментарий',
    style: { width: '400px' },
  },
];

export const alertsDisplayedCells = [
  'payDateCurrent',
  'companyName',
  'accountId',
  'typePayCurrent',
  'textAlignRight',
  'comment',
];
